import React, { useEffect } from 'react';

const DirectorsDesk = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-28 min-h-screen" style={{backgroundColor: '#F0FDF7'}}>
      {/* Header Section */}
      <header className="text-white relative overflow-hidden" style={{background: 'linear-gradient(135deg, #134E4A 0%, #0F3E3C 100%)'}}>
        <div className="absolute inset-0 bg-black opacity-10"></div>
        <div className="relative z-10 max-w-6xl mx-auto px-6 py-16">
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
            {/* Director's Image */}
            <div className="flex-shrink-0">
              <div className="w-48 h-48 md:w-56 md:h-56 rounded-full overflow-hidden border-4 border-white shadow-2xl" style={{backgroundColor: '#E0F2F1'}}>
                <img 
                  src="/images/mentors/sumant.jpg" 
                  alt="Sumant Kamble - Director, DIMENSIONIAS"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            {/* Director's Info */}
            <div className="text-center md:text-left max-w-md">
              <div className="w-24 h-1 bg-white opacity-60 mb-6 mx-auto md:mx-0"></div>
              <h2 className="text-2xl md:text-3xl font-medium mb-3">
                From the Director's Desk
              </h2>
              <h3 className="text-xl md:text-2xl font-light mb-2">
                Sumant Kamble
              </h3>
              <p className="text-lg opacity-90 font-light">
                Director & Founder, DimensionIAS
              </p>
              <p className="text-sm opacity-80 mt-2">
                UPSC Civil Services Mentor
              </p>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 -mt-16 relative z-20">
          {/* Director's Message */}
          <div className="prose prose-lg max-w-none">
            <div className="mb-8">
              <h3 className="text-2xl font-semibold mb-6 border-b-2 pb-3" style={{color: '#134E4A', borderColor: '#E0F2F1'}}>
                Dear Aspirants,
              </h3>
              <div className="space-y-6 leading-relaxed" style={{color: '#4A5568'}}>
                <p>
                  The journey to becoming a civil servant is not defined by the number of books you read, but by how well you understand the demand of the exam—and how consistently you meet it.
                </p>
                <p>
                  Having personally cleared multiple Prelims and appeared in the UPSC Interviews, I can tell you this with conviction: UPSC doesn't just test knowledge. It tests your balance, clarity, and decision-making under pressure. At <span className="font-semibold" style={{color: '#2DD4BF'}}>DimensionIAS</span>, this understanding is the foundation of everything we do.
                </p>
                <p>
                  We don't believe in overwhelming you with content. We believe in sharpening your approach.
                </p>
                <p>
                  That means:
                </p>
                <ul className="list-disc pl-6">
                  <li>Understanding the syllabus deeply—not just covering it.</li>
                  <li>Solving MCQs and writing answers with previous year trends in mind.</li>
                  <li>Focusing on thought clarity, not rote memorization.</li>
                  <li>And most importantly, preparing in a way that is sustainable over the long haul.</li>
                </ul>
                <p>
                  In these times where distractions are many and strategies are scattered, our role is not just to teach but to keep you anchored. That's why our One-to-One Mentorship isn't about motivation speeches—it's about personalised course correction, day by day, test by test.
                </p>
                <p>
                  Our Test Series, too, is not a formality. It's designed to build the exam temperament you need for both Prelims and Mains—through intelligent test design, performance tracking, and actionable feedback.
                </p>
                <p>
                  Many aspirants lose out not because they lack potential, but because they don't align their preparation with the exam's expectations. We want to make sure that doesn't happen to you.
                </p>
                <p>
                  We'll keep evolving, learning, and simplifying—so that you can focus not on "studying more," but on studying right.
                </p>
                <p>
                  Stay steady. Stay aware. The exam rewards those who prepare with insight, not just effort.
                </p>
              </div>
            </div>
            {/* Signature Section */}
            <div className="mt-12 pt-8 border-t border-gray-200">
              <div className="text-right">
                <p className="font-medium mb-1" style={{color: '#4A5568'}}>Warm regards,</p>
                <p className="text-xl font-bold mb-1" style={{color: '#134E4A'}}>Sumant Kamble</p>
                <p className="font-medium" style={{color: '#2DD4BF'}}>Director, DimensionIAS</p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default DirectorsDesk;